module.exports = __webpack_public_path__ + "static/img/pc-web-img-06@w.e489243.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/pc-web-img-06@w.png
// module id = Xf7B
// module chunks = 0